import React from 'react';
import { QuizPage } from './QuizPage';

/**
 * /PD1 — entry point that always opens on the qualifier quiz.
 *
 * The quiz owns the routing after that: visitors who pick the "money" branch
 * and confirm are redirected to /demo (the presentation lander), while the
 * adult branch redirects to the external partner URL and under-18 visitors are
 * hard-blocked inside the quiz.
 */
export function Pd1Page() {
  return <QuizPage data-id="element-673" data-mp="3iat20j4ukcq3" />;
}